export default __webpack_public_path__ + "static/media/1.106b689e.jpg";